import React, { useState } from "react";
import "../styles/changePassword.css";
import { resetPasswordEmailSendAction } from "../redux/slices/userSlices";
import { useDispatch } from "react-redux";
import Message from "./Message";
// npm i before running this file.
const ResetPasswordMail = () => {
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const handlemail = (e) => setEmail(e.target.value);

  const sendMail = () => {
    const data = {
      email: email,
    };

    dispatch(resetPasswordEmailSendAction(data));
  };

  return (
    <>
      <Message />
      <div className="password-container">
        <div className="pass-box">
          <h2>Reset Password</h2>
          <div className="input-group">
            <label htmlFor="old-password">Email :</label>
            <input
              type="email"
              id="old-password"
              value={email}
              onChange={handlemail}
              placeholder="Enter Email"
            />
          </div>

          <div className="buttons">
            <button className="save-btn" onClick={sendMail}>
              Send Link
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordMail;
